import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { DateFormatter } from '../core/base/utils/date-formatter.class';
import { IColumnExport } from '../core/interfaces/column-export.interface';


@Injectable({ providedIn: 'root' })
export class ExportDataService {
  constructor() { }

  private _saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const data: Blob = new Blob([buffer], { type: fileType });
    FileSaver.saveAs(data, fileName);
  }

  /** Save an already-built Blob (e.g. a shapefile zip streamed from the API). */
  public saveBlobAsFile(blob: Blob, fileName: string): void {
    FileSaver.saveAs(blob, fileName);
  }

  private _isNumeric = (num: any) =>
    (typeof num === 'number' ||
      (typeof num === 'string' && num.trim() !== '')) &&
    !isNaN(num as number);

  public exportDataToCsv(
    // eslint-disable-next-line @typescript-eslint/ban-types
    rows: object[],
    fileName: string,
    columns: IColumnExport[]
  ): string {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';

    // Use the union of keys across all rows: a row may omit keys whose value is null,
    // and optional associations (e.g. politiki_gi) may be absent on some rows.
    const keys = Array.from(
      new Set(rows.flatMap((row) => Object.keys(row)))
    );

    const columnsNotFound = columns
      .map((x) => x.column)
      .filter((x) => !keys.includes(x));

    if (columnsNotFound.length > 0) {
      // Don't fail the whole export because of missing/optional columns — skip them.
      console.warn(
        `Skipping columns not found in data: ${columnsNotFound.join(', ')}`
      );
    }

    // Only export columns that actually exist in the data.
    columns = columns.filter((x) => keys.includes(x.column));

    const csvContent =
      '\uFEFF' +
      columns.map((x) => x.translation).join(separator) +
      '\r\n' +
      rows
        .map((row) => {
          return columns
            .map((c) => {
              let cell =
                row[c.column] === null || row[c.column] === undefined
                  ? ''
                  : row[c.column];

              //To type δεν είναι ο πραγματικός τύπος του πεδίου. Ορίζει το πως θα γίνει η μορφοποίηση του πεδίου
              if (cell && c.type === 'number') {
                // cell = new NumberFormatter(cell).toLocalNumber(c?.format);
                cell = cell;
              } else if (cell && c.type === 'date') {
                cell = new DateFormatter(cell).toLocalDateTime(c?.format);
              }

              cell = cell.toString().replace(/"/g, '""');

              if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`;
              }

              return cell;
            })
            .join(separator);
        })
        .join('\r\n');

    this._saveAsFile(csvContent, `${fileName}.csv`, 'text/csv;charset=utf-8');
  }
}
